import { createSlice } from '@reduxjs/toolkit';
import { sendGeneralRequest } from '../generalRequest';

const initialState = {
    shouldDisplayInvoiceList: false,
    shouldDisplaySingleInvoice: false,
    shouldDisplayMainUtilityView: true,
    isTransactionSuccessfullyStarted: false,
    isTransactionSuccessfullyCompleted: false,
    isOfferTransactionSuccessfullyCompleted: false,
    selectedOffer: '',
    isConfirmationDialogOpen: false,
    subscriberBalance: '',
    transactionId: '',
    invoiceList: [],
    singleInvoice: {},
    isLoading: false
};

export const oneSlice = createSlice({
    name: 'one',
    initialState,
    reducers: {
        displayInvoiceList: (state) => {
            state.shouldDisplayInvoiceList = true
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayMainUtilityView = false
        },
        displaySingleInvoice: (state) => {
            state.shouldDisplaySingleInvoice = true
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = false
        },
        setSingleInvoice: (state, action) => {
            state.singleInvoice = action.payload
        },
        displayMainUtilityView: (state) => {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        displayOneMainUtilityView: (state) => {
            state.shouldDisplaySingleInvoice = false
            state.shouldDisplayInvoiceList = false
            state.shouldDisplayMainUtilityView = true
        },
        changeConfirmationDialogState: (state) => {
            state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen
        },
        setIsTransactionSuccessfullyStarted: (state, action) => {
            state.isTransactionSuccessfullyStarted = action.payload
        },
        setIsTransactionSuccessfullyCompleted: (state, action) => {
            state.isTransactionSuccessfullyCompleted = action.payload
        },
        setSubscriberBalance: (state, action) => {
            state.subscriberBalance = action.payload
        },
        setTransactionId: (state, action) => {
            state.transactionId = action.payload
        },
        setSelectedOffer: (state, action) => {
            state.selectedOffer = action.payload
        },
        resetOneSlice: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(sendGeneralRequest.pending, (state) => {
                state.isLoading = true
            })
            .addCase(sendGeneralRequest.rejected, (state) => {
                state.isLoading = false
            })
            .addCase(sendGeneralRequest.fulfilled, (state, action) => {
                state.isLoading = false
                if (action.payload.endpoint === 'ASBS/StartASBSTopUPMNO') {
                    state.transactionId = action.payload.response.transID
                    state.isTransactionSuccessfullyStarted = true
                }
                else if (action.payload.endpoint === 'ASBS/ConfirmASBSTopUPMNO') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.subscriberBalance = action.payload.response.SubscriberBalance
                }
                else if (action.payload.endpoint === 'ASBS/GetASBSListOfOffers') {
                    state.invoiceList = action.payload.response.offers.map(offer => { return { Emri: offer.Name, Pershkrimi: offer.productDescription, Vlera: offer.productValue + ' Leke', Id: offer.productID } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                    state.isTransactionSuccessfullyCompleted = false
                }
                else if (action.payload.endpoint === 'ASBS/ConfirmASBSMNOOffer') {
                    state.isOfferTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
                else if (action.payload.endpoint === 'DailyTransaction') {
                    state.lastTransactionsData = action.payload.response.lastTransactionsData
                }
                else if (action.payload.endpoint === 'ASBS/GetONEInvoices') {
                    state.invoiceList = action.payload.response.invoices.map(invoice => { return { Telefoni: invoice?.phone, Seriali: invoice.billNumber.toString(), Vlera: invoice.amount + ' Leke', Data: invoice.fromDate } })
                    state.shouldDisplayInvoiceList = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayMainUtilityView = false
                }
                else if (action.payload.endpoint === 'ASBS/StartONEInvoices') {
                    state.isTransactionSuccessfullyStarted = true
                    state.transactionId = action.payload.response.transID
                }
                else if (action.payload.endpoint === 'ASBS/ConfirmONEInvoices') {
                    state.isTransactionSuccessfullyStarted = false
                    state.isTransactionSuccessfullyCompleted = true
                    state.shouldDisplaySingleInvoice = false
                    state.shouldDisplayInvoiceList = false
                    state.shouldDisplayMainUtilityView = true
                }
            })
    },
})
export const { displayInvoiceList, displaySingleInvoice, resetOneSlice, displayMainUtilityView, changeConfirmationDialogState, setSelectedOffer, setIsTransactionSuccessfullyCompleted, setIsTransactionSuccessfullyStarted, setTransactionId, setSubscriberBalance, setSingleInvoice, displayOneMainUtilityView } = oneSlice.actions;

export const selectOneState = (state) => state.one;

export default oneSlice.reducer;

